import { Box, TextField, Typography } from '@mui/material'
import React from 'react'
import { averageStyle, newBtnStyle, typoStyle } from "../styles/globalStyle"
import IzostatikPresModal from '../components/modals/IzostatikPresModal';
import useArge from '../hooks/useArge';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import { useState } from 'react';
import DeleteModals from '../components/deleteModals/DeleteModals';
import IzoStatikPres_DataTable from '../components/tables/IzoStatikPres_DataTable';
import { HiOutlineSearch } from "react-icons/hi";
import { toastWarnNotify } from '../helpers/ToastNotify';



const Izostatikpres = () => {

  let getVardiya = 0;
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const { getFireData, getMaterialCenter, getWorkCenter } = useArge()
  const { currentUser } = useSelector((state) => state.auth)
  const { workCenterCode, materialCode, izoStatikPresData, loading } = useSelector((state) => state.arge)

  const [averages, setAverages] = useState({
    agirlik: 0,
    taban: 0,
    kenar: 0,
    pkenar: 0,
    cap: 0,
  });

  const [infoDate, setInfoDate] = useState({
    dateFrom: "",
    dateTo: ""
  })

  const getShift = () => {
    //! padStart(2,'0') metodu ile hedefUzunluk ve eklenecek karakterler olarak iki parametre alır.
    const hour = new Date().getHours().toString().padStart(2, '0')

    if (hour > 8 && hour < 16) {
      getVardiya = 2
    }
    else if (hour > 16 && hour < 23) {
      getVardiya = 3
    }
    else {
      getVardiya = 1
    }

    return getVardiya

  }

  const [info, setInfo] = useState({
    department: "Sekillendirme",
    type: "IzoStatikPresData",
    is_merkezi: "",
    agirlik: "",
    taban: "",
    kenar: "",
    pkenar: "",
    cap: "",
    izobasinc: "",
    kapamabasinc: "",
    vakumdegeri: "",
    dolumsuresi: "",
    granulturu: "",
    urun_kodu: "",
    catlakkontrol: "",
    rotuskontrol: "",
    yuzeykontrol: "",
    hamurunistif: "",
    uygunsuzluktipi: "",
    aciklama: "",
    vardiyasorumlusu: "",
    oldData_date: "",
    vardiya: getShift(),
    date: "",
    time: "",
    kontroleden_kisi: currentUser,
    newMaterialName: ""
  })

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false)
    setInfo({
      type: "IzoStatikPresData",
      is_merkezi: "",
      agirlik: "",
      taban: "",
      kenar: "",
      pkenar: "",
      cap: "",
      izobasinc: "",
      kapamabasinc: "",
      vakumdegeri: "",
      dolumsuresi: "",
      granulturu: "",
      urun_kodu: "",
      catlakkontrol: "",
      rotuskontrol: "",
      yuzeykontrol: "",
      hamurunistif: "",
      uygunsuzluktipi: "",
      aciklama: "",
      vardiyasorumlusu: "",
      oldData_date: "",
      vardiya: getShift().toString(),
      date: "",
      time: "",
      kontroleden_kisi: currentUser,
      newMaterialName: ""
    })
  }

  const [delOpen, setdelOpen] = React.useState(false);
  const delHandleOpen = () => setdelOpen(true);
  const delHandleClose = () => setdelOpen(false);


  useEffect(() => {
    getMaterialCenter() //makine isimlerini çek
    getWorkCenter() //ürün kodlarını çek

    getFireData("IzoStatikPresData") //firebase den verileri getir
  }, [])


  // istatistik datasındaki ortalama hesaplamasını yapar
  useEffect(() => {
    const dizi = Object.keys(izoStatikPresData).map(key => { return { id: key, ...izoStatikPresData[key] } })
    dizi.sort((a, b) => {
      const convertDateTime = (date, time) => {
        if (!date || !time) {
          return new Date(0); // 1 Ocak 1970
        }
        const [day, month, year] = date.split('-').map(num => num.padStart(2, '0'));
        const [hours, minutes] = time.split(':').map(num => num.padStart(2, '0'));
        return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
      };

      const dateTimeA = convertDateTime(a.date, a.time);
      const dateTimeB = convertDateTime(b.date, b.time);

      return dateTimeB - dateTimeA;
    });

    // Ortalama hesaplamaları
    const total = {
      agirlik: 0,
      taban: 0,
      kenar: 0,
      pkenar: 0,
      cap: 0,
    };
    const count = dizi.length;

    dizi.forEach(item => {
      total.agirlik += parseFloat(item.agirlik) || 0;
      total.taban += parseFloat(item.taban) || 0;
      total.kenar += parseFloat(item.kenar) || 0;
      total.pkenar += parseFloat(item.pkenar) || 0;
      total.cap += parseFloat(item.cap) || 0;
    });

    const averages = {
      agirlik: (total.agirlik / count).toFixed(2),
      taban: (total.taban / count).toFixed(2),
      kenar: (total.kenar / count).toFixed(2),
      pkenar: (total.pkenar / count).toFixed(2),
      cap: (total.cap / count).toFixed(2),
    };

    // setpresData(dizi);
    setAverages(averages); // Ortalamaları state'e kaydediyoruz
  }, [izoStatikPresData]);


  const handleChangeDate = (e) => {
    const { name, value } = e.target
    setInfoDate({ ...infoDate, [name]: value })
  }

  const handleDateFilter = () => {

    if (infoDate.dateFrom && infoDate.dateTo) {

      //! tarih filtreleme işleminde son seçilen sarih bilgisi localStorage taragında saklanır.
      // localStorage.setItem('lastSelectedDate', JSON.stringify(info))

      getFireData('IzoStatikPresData', infoDate.dateFrom, infoDate.dateTo)

    }
    else {
      toastWarnNotify('Tarih bilgisini kontrol ediniz !')
    }

  }

console.log(workCenterCode)

  return (

    <div>
      <Typography mt={8} align='center' variant='h5' fontWeight={700} sx={typoStyle}>
        İzostatik Pres
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

        <Box>
          <Button onClick={handleOpen} variant='outlined' sx={newBtnStyle}>New</Button>
        </Box>


        <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1, alignItems: 'center', p: 2 }}>
          <Typography>From</Typography>
          <TextField
          size='small'
            required
            id='dateFrom'
            name='dateFrom'
            type='date'
            value={infoDate.dateFrom}
            onChange={handleChangeDate}
          />

          <Typography>To</Typography>
          <TextField
          size='small'
            required
            id='dateTo'
            name='dateTo'
            type='date'
            value={infoDate.dateTo}
            onChange={handleChangeDate}
          />
          <HiOutlineSearch size={30} color='black' onClick={handleDateFilter} cursor={'pointer'} style={{ marginLeft: 15 }} />
        </Box>

      </Box>


      <IzostatikPresModal open={open} handleClose={handleClose} info={info} setInfo={setInfo} workCenterCode={workCenterCode} materialCode={materialCode} />

      <DeleteModals delOpen={delOpen} delHandleClose={delHandleClose} delHandleOpen={delHandleOpen} setdelOpen={setdelOpen} info={info} />




      <Box>
        {
          loading ?
            (
              <Typography>Loading..</Typography>
            )
            :
            (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>

                  <Typography style={averageStyle}>Ağırlık : {averages.agirlik}</Typography>
                  <Typography style={averageStyle}>Çap : {averages.cap}</Typography>
                  <Typography style={averageStyle}>Kenar : {averages.kenar}</Typography>
                  <Typography style={averageStyle}>Pkenar : {averages.pkenar}</Typography>
                  <Typography style={averageStyle}>Taban : {averages.taban}</Typography>

                </Box>

                <IzoStatikPres_DataTable handleOpen={handleOpen} delHandleOpen={delHandleOpen} setInfo={setInfo} info={info} izoStatikPresData={izoStatikPresData} setFilterModel={setFilterModel} filterModel={filterModel}/>
              </Box>
            )
        }
      </Box>



    </div>

  )
}

export default Izostatikpres